import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Box } from 'grid-styled';

const HeaderWrapper = styled(Box) `
  width: 100%;
  align-self: flex-start;
  display: none;
  /* overflow: hidden; */

  @media only screen and (max-width: ${props => props.theme.mq.large}) {
    display: flex;
    /* position: absolute; */
    width: 100%;
    border-bottom: 1px solid ${props => props.theme.colors.xDarkgray};
    z-index: ${props => props.theme.zIndex.headerMobile};
  }
`;

class Header extends React.Component {
  render() {

    const { isLoggedIn } = this.props;
    return (
      <React.Fragment>
        {isLoggedIn && (
          <HeaderWrapper width={1 / 1} is="header">
            {this.props.children}
          </HeaderWrapper>
        )}
        {!isLoggedIn && <div />}
      </React.Fragment>
    );
  }
}
Header.defaultProps = {
  isLoggedIn: false
};

Header.propTypes = {
  isLoggedIn: PropTypes.bool
};

export default Header;



// WEBPACK FOOTER //
// ./src/components/BasePage/Header.js